import React, { useState, useEffect, useRef } from 'react';
import SearchInput from './SearchInput';
import { IoCartOutline } from "react-icons/io5";
import { LuHelpCircle } from "react-icons/lu";
import { NavLink, useNavigate } from 'react-router-dom';
import { PiDotsNine } from "react-icons/pi";
import { FaMinus, FaPlus, FaPrint } from 'react-icons/fa';
import { useStateContext } from '../contexts/ContextProvider';
import { getProducts } from '../lib/apiService';
import { GoTrash } from 'react-icons/go';
import useIsMobileDevice from '../hooks/useIsMobileDevice';
import { HiMiniBars3BottomLeft } from "react-icons/hi2";
import { CiSearch } from "react-icons/ci";



const ProductCard = ({ product }) => {
    const { cartItems, setCartItems } = useStateContext();
    const [quantity, setQuantity] = useState(product.quantity);
    const isProductInCart = cartItems.products.some(item => item.slug === product.slug);

    const handleAddToCart = () => {
        if (!isProductInCart){
          if (quantity > 0) {
    
            const cartItem = {
              slug: product.slug,
              name: product.name,
              description: product.description,
              imageUrl: product.imageUrl,
              price: product.price,
              quantity: quantity,
            };
      
            setCartItems({
              ...cartItems,
              products: [...cartItems.products, cartItem]
            });
    
          }
        } else {
          const updatedCartItems = cartItems.products.filter(item => item.slug !== product.slug);
          setCartItems({
            ...cartItems,
            products: updatedCartItems
          });
        }
        
      };
    
    const handleQuantityChange = (action) => {
        if (action === 'increment') {
            setQuantity(prevQuantity => prevQuantity + 1);
        } else if (action === 'decrement') {
            if (product.quantity > 0) {
                setQuantity(prevQuantity => prevQuantity - 1);
            }
        }
        if (isProductInCart) {
            const updatedCartItems = cartItems.products.map(item => {
            if (item.slug === product.slug) {
                return { ...item, quantity: quantity };
            }
            return item;
            });
            setCartItems({
            ...cartItems,
            products: updatedCartItems
            });
        }
    };
    return (
        <div key={product.id} className="flex flex-row mb-2 items-center p-2 border border-gray-300 shadow-md rounded-md">
            <img src={product.imageUrl} alt={product.name} className="w-16 h-16 object-cover mr-4 rounded bg-gray-200" />
            <div className="basis-1/2 flex-grow">
                <h3 className="text-lg font-semibold">{product.name}</h3>
                <p className="text-gray-600">{product.description}</p>
                <h1 className='text-lg font-bold text-green-400'>DA {product.price}</h1>
            </div>
            
            <div className='basis-1/4 flex flex-col justify-between items-end w-full my-2'>
                
                <div className='flex flex-col items-end gap-6'>
                    <button
                        title={isProductInCart ? 'Remove from cart' : 'Add to cart'}
                        className='border border-gray-400 hover:text-white p-2 rounded-md hover:bg-blue-500'
                        onClick={handleAddToCart}
                    >
                        {isProductInCart ? <GoTrash /> : <IoCartOutline />}
                    </button>
                    <div className='flex flex-row items-center gap-2'>
                            <div className='flex flex-row w-full text-xs items-center justify-center border border-gray-400 rounded-md p-0.5'>
                                <button
                                    className='p-2 hover:text-white rounded-md hover:bg-blue-500'
                                    onClick={() => handleQuantityChange('increment')}
                                >
                                    <FaPlus />
                                </button>
                                <div className='border-l border-gray-400 h-full'></div> {/* Separator */}
                                <button
                                    className='p-2 hover:text-white rounded-md hover:bg-blue-500'
                                    onClick={() => handleQuantityChange('decrement')}
                                >
                                    <FaMinus />
                                </button>
                            </div>
                            <span className='font-semibold text-sm'>{quantity}</span>
                    </div>
                    
                </div>
            </div>
        </div>

    );
}

const Navbar = () => {
    const navigate = useNavigate();
    const { cartItems, handleClick, isClicked } = useStateContext();
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
    const [isSearchActive, setIsSearchActive] = useState(false);
    const searchInputRef = useRef(null);  
    const [searchBoxStyle, setSearchBoxStyle] = useState({});
    const isMobileDevice = useIsMobileDevice();
    // const [isSearchBoxVisible, setIsSearchBoxVisible] = useState(false);
    const [isDropdownOpenMenu, setIsDropdownOpenMenu] = useState(false);

    useEffect(() => {
        const fetchProducts = async () => {
            setLoading(true);
            if (searchTerm) {
                const { products } = await getProducts({ searchTerm });
                setSearchResults(products.map(product => ({
                    ...product,
                    isProductInCart: cartItems.products.some(item => item.slug === product.slug),
                    quantity: cartItems.products.find(item => item.slug === product.slug)?.quantity || 0,
                })));
            } else {
                setSearchResults([]);
            }
            setLoading(false);
        };
        fetchProducts();
    }, [searchTerm]);

    useEffect(() => {
        if (searchInputRef.current) {
            const { x, width } = searchInputRef.current.getBoundingClientRect();
            setSearchBoxStyle({
                left: x,
                width: width,
                // top: bottom + window.scrollY,
                top: 60
            });
        }
    }, [isSearchActive, searchTerm]);

    

    return (
        <div className='relative sticky top-0 z-50'>
            {/* Navbar */}
            {!isMobileDevice ? (
                <div className='flex flex-row justify-around border border-spacing-1 bg-slate-50 px-2 py-3 shadow-sm'>
                <div>
                    <h1 className='text-2xl font-bold font-satisfy hover:cursor-pointer hover:text-blue-400' onClick={() => navigate("/")}>
                        <NavLink to="/" className={({ isActive }) => isActive ? "text-blue-400" : ""}>Print Online</NavLink>
                    </h1>
                </div>
                <div className='basis-1/2 flex flex-row items-center justify-end gap-2'>
                    <div ref={searchInputRef} className="w-2/3" style={{ zIndex: 60 }}>
                        <SearchInput
                            placeholder={'Trouvez un article'}
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setIsSearchActive(true);
                            }}
                            onBlur={() => setIsSearchActive(false)}
                            classNameContainer={'opacity-100 flex flex-row items-center bg-white border border-gray-300 rounded-md p-1'}
                        />
                    </div>
                    <NavLink to="/products" className={({ isActive }) => `p-2 hover:cursor-pointer hover:text-blue-400 flex flex-row justify-center items-center gap-1 ${isActive ? "text-blue-400" : "text-gray-600"}`}>
                        <PiDotsNine />
                        <p className='text-sm'>Our products</p>
                    </NavLink>
                    <NavLink
                        to="/print"
                        className={({ isActive }) => `p-2 hover:cursor-pointer hover:text-blue-400 flex flex-row justify-center items-center gap-1 ${isActive ? "text-blue-400" : "text-gray-600"}`}
                    >
                        <FaPrint />
                        <p className='text-sm'>Print</p>
                    </NavLink>
                </div>
                <div className='flex flex-row gap-2 items-center justify-center'>
                    <NavLink
                        to="/guide"
                        className={({ isActive }) => `bg-white border border-gray-500 p-2 h-8 hover:cursor-pointer hover:text-blue-400 hover:border-blue-400 ${isActive ? "text-blue-400 border-blue-400" : ""}`}
                    >
                        <LuHelpCircle />
                    </NavLink>
                    <NavLink
                        to="/cart"
                        className={({ isActive }) => `flex flex-row items-center justify-center h-8 gap-1 bg-white border border-gray-500 p-2 hover:cursor-pointer hover:text-blue-400 hover:border-blue-400 ${isActive ? "text-blue-400 border-blue-400" : ""}`}
                    >
                        <IoCartOutline />
                        <span className='text-sm'>{` ${cartItems.products.length + cartItems.documents.length}`}</span>
                    </NavLink>
                </div>
            </div>
            ): (
                <div className='flex flex-row justify-between p-4 z-10 bg-slate-50'>
                    <div className='flex flex-row items-center justify-between gap-3 text-2xl'>
                        <HiMiniBars3BottomLeft
                            className={`flex flex-row items-center justify-center hover:cursor-pointer hover:text-blue-400 hover:border-blue-400 ${isDropdownOpenMenu ? "text-blue-400 border-blue-400" : ""}`}
                            onClick={(e) => handleClick(e, 'menuDropDown')}
                        />
                        <CiSearch
                            className={`flex flex-row items-center justify-center hover:cursor-pointer hover:text-blue-400 hover:border-blue-400 ${isSearchActive ? "text-blue-400 border-blue-400" : ""}`}
                            onClick={(e) => handleClick(e, 'searchBox')}
                        />
                    </div>
                    <h1 className='text-2xl font-bold font-satisfy hover:cursor-pointer hover:text-blue-400' onClick={() => navigate("/")}>
                        <NavLink to="/" className={({ isActive }) => isActive ? "text-blue-400" : ""}>Print Online</NavLink>
                    </h1>
                    <div className='flex flex-row items-center justify-between gap-3 text-2xl'>
                        <NavLink
                            to="/guide"
                            className={({ isActive }) => `flex flex-row items-center justify-center hover:cursor-pointer hover:text-blue-400 hover:border-blue-400 ${isActive ? "text-blue-400 border-blue-400" : ""}`}
                        >
                            <LuHelpCircle />
                        </NavLink>
                        <NavLink
                            to="/cart"
                            className={({ isActive }) => `relative flex flex-row items-center justify-center hover:cursor-pointer hover:text-blue-400 hover:border-blue-400 ${isActive ? "text-blue-400 border-blue-400" : ""}`}
                        >
                            <IoCartOutline />
                            {cartItems.products.length + cartItems.documents.length > 0 && (
                                <div
                                    className="absolute top-0 right-0 w-1 h-1 bg-red-500 rounded-full"
                                ></div>
                            )}
                        </NavLink>
                    </div>
                </div>
            )}

            {/* Dropdown Menu */}
            {isClicked.menuDropDown && (
                <div
                    className="flex flex-col justify-start items-start px-4 py-2 bg-slate-50 w-full"
                    // onClick={(e) => handleClick(e, 'menuDropDown')}
                >
                    {/* Products Link */}
                    <NavLink to="/products" className={({ isActive }) => `p-2 hover:cursor-pointer hover:text-blue-400 flex flex-row justify-center items-center gap-1 ${isActive ? "text-blue-400" : "text-gray-600"}`}>
                        <PiDotsNine />
                        <p className='text-sm'>Our products</p>
                    </NavLink>

                    {/* Print Link */}
                    <NavLink
                        to="/print"
                        className={({ isActive }) => `p-2 hover:cursor-pointer hover:text-blue-400 flex flex-row justify-center items-center gap-1 ${isActive ? "text-blue-400" : "text-gray-600"}`}
                    >
                        <FaPrint />
                        <p className='text-sm'>Print</p>
                    </NavLink>

                </div>
            )}
            {/* Search Box */}
            {isClicked.searchBox && (
                <div
                    ref={searchInputRef}
                    className="mx-auto w-[90%] p-4"
                    style={{ zIndex: 60 }}
                    onClick={(e) => handleClick(e, 'searchBox')}
                >
                    <SearchInput
                        placeholder={'Trouvez un article'}
                        value={searchTerm}
                        onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setIsSearchActive(true);
                        }}
                        onBlur={() => setIsSearchActive(false)}
                        classNameContainer={'opacity-100 flex flex-row items-center bg-white border border-gray-300 rounded-md p-1'}
                    />
                </div>
            )}
            

            {/* Dark Overlay */}
            {isSearchActive && (
                <div className="fixed inset-0 bg-black opacity-50 z-40" onClick={() => { setSearchTerm(""); setIsSearchActive(false); }}></div>
            )}

            {/* Search Results Box */}
            {isSearchActive && (
                <div 
                    className="absolute mt-2 bg-white rounded-md shadow-lg p-4 z-50 overflow-y-auto"
                    style={{
                        ...searchBoxStyle,
                        height: "60vh",
                    }}
                >
                    {loading && (
                        <div className="flex justify-center items-center h-full">
                            <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-blue-500"></div>
                        </div>
                    )}
                    
                    {!loading && searchResults.length > 0 && (
                        <>
                            <h1 className='text-gray-400 font-bold mb-2'>Products</h1>
                            {searchResults.map(product => (
                                <ProductCard key={product.id} product={product} />
                            ))}
                        </>
                    )}
                    {!loading && searchResults.length === 0 && (
                        <p className="text-gray-500 text-center">No products found</p>
                    )}
                </div>
            )}
        </div>
    );
};

export default Navbar;